import { render, staticRenderFns } from "./DashboardDocuments.vue?vue&type=template&id=742b070a"
import script from "./DashboardDocuments.vue?vue&type=script&lang=ts"
export * from "./DashboardDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742b070a')) {
      api.createRecord('742b070a', component.options)
    } else {
      api.reload('742b070a', component.options)
    }
    module.hot.accept("./DashboardDocuments.vue?vue&type=template&id=742b070a", function () {
      api.rerender('742b070a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardDocuments.vue"
export default component.exports